// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.en-container {
  padding: 0.75rem;
  width: 100%;
  box-sizing: border-box;
}

/* ── Controls bar ─────────────────────────────────────────────────────────── */

.en-controls {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 1rem;
}

.en-control-group {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.en-control-group label {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  white-space: nowrap;
}

.en-select {
  padding: 6px 10px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s;
}

.en-select:focus {
  outline: none;
  border-color: #667eea;
}

/* ── Toggle group (Day / Week / Month) ───────────────────────────────────── */

.en-toggle-group {
  display: flex;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
}

.en-toggle-group button {
  padding: 5px 14px;
  border: none;
  background: #fff;
  font-size: 0.875rem;
  cursor: pointer;
  color: #374151;
  transition: background 0.15s, color 0.15s;
}

.en-toggle-group button + button {
  border-left: 1.5px solid #d1d5db;
}

.en-toggle-group button.active {
  background: #667eea;
  color: #fff;
  font-weight: 600;
}

.en-toggle-group button:hover:not(.active):not(:disabled) {
  background: #f3f4f6;
}

.en-toggle-group button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Summary cards ────────────────────────────────────────────────────────── */

.en-summary-cards {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.en-card {
  flex: 1 1;
  min-width: 150px;
  background: #fff;
  border-radius: 8px;
  padding: 0.9rem 1.1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.en-card-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
  margin-bottom: 0.3rem;
}

.en-card-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  font-variant-numeric: tabular-nums;
}

.en-card-diff {
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 0.15rem;
  font-variant-numeric: tabular-nums;
}

/* ── Tables ───────────────────────────────────────────────────────────────── */

.en-table-wrap {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow-x: auto;
}

.en-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.en-table thead tr {
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
}

.en-table th {
  padding: 0.65rem 0.9rem;
  text-align: right;
  font-weight: 600;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  white-space: nowrap;
  cursor: default;
}

.en-table th:first-child {
  text-align: left;
}

.en-table td {
  padding: 0.55rem 0.9rem;
  text-align: right;
  border-bottom: 1px solid #f3f4f6;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: #111827;
}

.en-table td.en-period {
  text-align: left;
  font-weight: 500;
  color: #374151;
}

.en-table td.en-total-col {
  font-weight: 600;
}

.en-table tbody tr:hover {
  background: #f9fafb;
}

.en-table tbody tr:last-child td {
  border-bottom: none;
}

.en-empty {
  text-align: center !important;
  color: #9ca3af;
  padding: 2rem !important;
  font-style: italic;
}

/* ── Positive / negative colours ─────────────────────────────────────────── */

.en-positive {
  color: #059669 !important;
}

.en-negative {
  color: #dc2626 !important;
}

/* ── Loading / error ──────────────────────────────────────────────────────── */

.en-loading {
  padding: 2rem;
  text-align: center;
  color: #6b7280;
}

.en-error {
  padding: 1rem;
  background: #fef2f2;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  color: #b91c1c;
  margin-bottom: 1rem;
}

/* ── Equity charts section ────────────────────────────────────────────────── */

.en-charts-section {
  margin-top: 1.5rem;
}

.en-charts-heading {
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.75rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.en-charts-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

@media (max-width: 860px) {
  .en-charts-grid {
    grid-template-columns: 1fr;
  }
}

.en-chart-panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 1rem;
}

.en-chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.en-chart-title {
  font-weight: 600;
  font-size: 0.9rem;
  color: #111827;
}

.en-chart-start {
  font-size: 0.8rem;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}

.en-chart-header-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* ── Goal badges (on-track indicators) ───────────────────────────────────── */

.en-goal-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}

.en-goal-badge--on {
  background: #d1fae5;
  color: #065f46;
}

.en-goal-badge--off {
  background: #fee2e2;
  color: #991b1b;
}

.en-goal-badge--stretch.en-goal-badge--on {
  background: #ede9fe;
  color: #5b21b6;
}

.en-goal-badge--stretch.en-goal-badge--off {
  background: #fef3c7;
  color: #92400e;
}

/* ── Chart legend ─────────────────────────────────────────────────────────── */

.en-chart-legend {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.25rem;
  padding: 0 4px;
}

.en-legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  color: #6b7280;
}

.en-legend-item::before {
  content: '';
  display: inline-block;
  width: 20px;
  height: 2px;
  border-radius: 1px;
}

.en-legend-equity::before {
  background: var(--lc, #667eea);
}

.en-legend-goal::before {
  background: rgba(245, 158, 11, 0.5);
  border-top: 2px dashed rgba(245, 158, 11, 0.5);
  height: 0;
}

.en-legend-stretch::before {
  background: rgba(139, 92, 246, 0.5);
  border-top: 2px dashed rgba(139, 92, 246, 0.5);
  height: 0;
}

/* ── Year-end targets summary ─────────────────────────────────────────────── */

.en-chart-targets {
  font-size: 0.72rem;
  color: #6b7280;
  margin-top: 0.25rem;
  padding: 0 4px;
}

.en-target-normal {
  color: rgba(180, 116, 8, 0.9);
  font-weight: 500;
}

.en-target-stretch {
  color: rgba(109, 72, 196, 0.9);
  font-weight: 500;
}

.en-chart-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 240px;
  color: #9ca3af;
  font-style: italic;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

/* ── P&L side-by-side grid ────────────────────────────────────────────────── */

.en-pnl-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

@media (max-width: 800px) {
  .en-pnl-grid {
    grid-template-columns: 1fr;
  }
}

.en-pnl-panel {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.en-pnl-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.4rem 0.2rem;
}

.en-pnl-broker-label {
  font-weight: 700;
  font-size: 1rem;
  color: #111827;
}

.en-pnl-total {
  font-weight: 600;
  font-size: 0.9rem;
  font-variant-numeric: tabular-nums;
}

.en-pnl-note {
  font-size: 0.75rem;
  color: #6b7280;
  background: #f9fafb;
  border-left: 3px solid #d1d5db;
  padding: 0.4rem 0.6rem;
  border-radius: 0 4px 4px 0;
  margin-bottom: 0.5rem;
}

.en-pnl-footnote {
  font-size: 0.72rem;
  color: #9ca3af;
  padding: 0.4rem 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/EquityNew.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,gFAAgF;;AAEhF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;EAChC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,+EAA+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,SAAS;AACX;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".en-container {\n  padding: 0.75rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ── Controls bar ─────────────────────────────────────────────────────────── */\n\n.en-controls {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  margin-bottom: 1rem;\n}\n\n.en-control-group {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.en-control-group label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 0.875rem;\n  white-space: nowrap;\n}\n\n.en-select {\n  padding: 6px 10px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.en-select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n/* ── Toggle group (Day / Week / Month) ───────────────────────────────────── */\n\n.en-toggle-group {\n  display: flex;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.en-toggle-group button {\n  padding: 5px 14px;\n  border: none;\n  background: #fff;\n  font-size: 0.875rem;\n  cursor: pointer;\n  color: #374151;\n  transition: background 0.15s, color 0.15s;\n}\n\n.en-toggle-group button + button {\n  border-left: 1.5px solid #d1d5db;\n}\n\n.en-toggle-group button.active {\n  background: #667eea;\n  color: #fff;\n  font-weight: 600;\n}\n\n.en-toggle-group button:hover:not(.active):not(:disabled) {\n  background: #f3f4f6;\n}\n\n.en-toggle-group button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ── Summary cards ────────────────────────────────────────────────────────── */\n\n.en-summary-cards {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.en-card {\n  flex: 1;\n  min-width: 150px;\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.9rem 1.1rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n\n.en-card-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #6b7280;\n  margin-bottom: 0.3rem;\n}\n\n.en-card-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111827;\n  font-variant-numeric: tabular-nums;\n}\n\n.en-card-diff {\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-top: 0.15rem;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Tables ───────────────────────────────────────────────────────────────── */\n\n.en-table-wrap {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  overflow-x: auto;\n}\n\n.en-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.en-table thead tr {\n  background: #f9fafb;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.en-table th {\n  padding: 0.65rem 0.9rem;\n  text-align: right;\n  font-weight: 600;\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n  white-space: nowrap;\n  cursor: default;\n}\n\n.en-table th:first-child {\n  text-align: left;\n}\n\n.en-table td {\n  padding: 0.55rem 0.9rem;\n  text-align: right;\n  border-bottom: 1px solid #f3f4f6;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  color: #111827;\n}\n\n.en-table td.en-period {\n  text-align: left;\n  font-weight: 500;\n  color: #374151;\n}\n\n.en-table td.en-total-col {\n  font-weight: 600;\n}\n\n.en-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.en-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.en-empty {\n  text-align: center !important;\n  color: #9ca3af;\n  padding: 2rem !important;\n  font-style: italic;\n}\n\n/* ── Positive / negative colours ─────────────────────────────────────────── */\n\n.en-positive {\n  color: #059669 !important;\n}\n\n.en-negative {\n  color: #dc2626 !important;\n}\n\n/* ── Loading / error ──────────────────────────────────────────────────────── */\n\n.en-loading {\n  padding: 2rem;\n  text-align: center;\n  color: #6b7280;\n}\n\n.en-error {\n  padding: 1rem;\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  border-radius: 6px;\n  color: #b91c1c;\n  margin-bottom: 1rem;\n}\n\n/* ── Equity charts section ────────────────────────────────────────────────── */\n\n.en-charts-section {\n  margin-top: 1.5rem;\n}\n\n.en-charts-heading {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 0.75rem 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.en-charts-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n@media (max-width: 860px) {\n  .en-charts-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.en-chart-panel {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  padding: 1rem;\n}\n\n.en-chart-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.en-chart-title {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #111827;\n}\n\n.en-chart-start {\n  font-size: 0.8rem;\n  color: #6b7280;\n  font-variant-numeric: tabular-nums;\n}\n\n.en-chart-header-right {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* ── Goal badges (on-track indicators) ───────────────────────────────────── */\n\n.en-goal-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.en-goal-badge--on {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.en-goal-badge--off {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.en-goal-badge--stretch.en-goal-badge--on {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n\n.en-goal-badge--stretch.en-goal-badge--off {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n/* ── Chart legend ─────────────────────────────────────────────────────────── */\n\n.en-chart-legend {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.25rem;\n  padding: 0 4px;\n}\n\n.en-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.72rem;\n  color: #6b7280;\n}\n\n.en-legend-item::before {\n  content: '';\n  display: inline-block;\n  width: 20px;\n  height: 2px;\n  border-radius: 1px;\n}\n\n.en-legend-equity::before {\n  background: var(--lc, #667eea);\n}\n\n.en-legend-goal::before {\n  background: rgba(245, 158, 11, 0.5);\n  border-top: 2px dashed rgba(245, 158, 11, 0.5);\n  height: 0;\n}\n\n.en-legend-stretch::before {\n  background: rgba(139, 92, 246, 0.5);\n  border-top: 2px dashed rgba(139, 92, 246, 0.5);\n  height: 0;\n}\n\n/* ── Year-end targets summary ─────────────────────────────────────────────── */\n\n.en-chart-targets {\n  font-size: 0.72rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n  padding: 0 4px;\n}\n\n.en-target-normal {\n  color: rgba(180, 116, 8, 0.9);\n  font-weight: 500;\n}\n\n.en-target-stretch {\n  color: rgba(109, 72, 196, 0.9);\n  font-weight: 500;\n}\n\n.en-chart-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 240px;\n  color: #9ca3af;\n  font-style: italic;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n\n/* ── P&L side-by-side grid ────────────────────────────────────────────────── */\n\n.en-pnl-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n@media (max-width: 800px) {\n  .en-pnl-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.en-pnl-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.en-pnl-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.4rem 0.2rem;\n}\n\n.en-pnl-broker-label {\n  font-weight: 700;\n  font-size: 1rem;\n  color: #111827;\n}\n\n.en-pnl-total {\n  font-weight: 600;\n  font-size: 0.9rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.en-pnl-note {\n  font-size: 0.75rem;\n  color: #6b7280;\n  background: #f9fafb;\n  border-left: 3px solid #d1d5db;\n  padding: 0.4rem 0.6rem;\n  border-radius: 0 4px 4px 0;\n  margin-bottom: 0.5rem;\n}\n\n.en-pnl-footnote {\n  font-size: 0.72rem;\n  color: #9ca3af;\n  padding: 0.4rem 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
